import { render, staticRenderFns } from "./ItsOrderInBoundDetail.vue?vue&type=template&id=c8c1478a&scoped=true&"
import script from "./ItsOrderInBoundDetail.vue?vue&type=script&lang=js&"
export * from "./ItsOrderInBoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsOrderInBoundDetail.vue?vue&type=style&index=0&id=c8c1478a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c1478a",
  null
  
)

export default component.exports